export function nth(n) {
  return ["st", "nd", "rd"][((((n + 90) % 100) - 10) % 10) - 1] || "th";
}

export const currencyCodes = {
  CAD: "CAD",
  GBP: "GBP",
  USD: "USD",
};

const currencySymbols = {
  CAD: "$",
  GBP: "£",
  USD: "$",
};
const usCountryCode = "us";

export function formatCurrency(num, currencyCode = "", fixedDecimalPlaces = 2) {
  const currency = currencySymbols[currencyCode] || "";

  if (!num) {
    return `${currency}0`;
  }

  num = parseFloat(num).toFixed(fixedDecimalPlaces);
  var parts = num.toString().split(".");
  return (
    currency +
    parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
    (parts[1] ? "." + parts[1] : "")
  );
}

export function formatNumber(numString) {
  return numString
    ? numString.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    : 0;
}

export function getDynamicFontSize(text) {
  let fontSize = 56;
  let divisor = 14;
  if (window.innerWidth < 992) {
    fontSize = 40;
    divisor = 10;
  }
  //   if (window.innerWidth < 1040) {
  //     fontSize = 70;
  //     divisor = 10;
  // }
  //   if (window.innerWidth < 601) {
  //       fontSize = 70;
  //       divisor = 20;
  //   }
  const dynamicTextFontSize = fontSize / (text.length / divisor);
  return dynamicTextFontSize > fontSize ? fontSize : dynamicTextFontSize;
}

export function pluralizeText(text, count, altPluralization) {
  return count === 1 ? text : altPluralization || text + "s";
}

export function removeEmptyFromObj(obj) {
  Object.keys(obj).forEach((key) => {
    if (obj[key] && typeof obj[key] === "object") removeEmptyFromObj(obj[key]);
    else if (obj[key] === null || obj[key] === "") delete obj[key];
  });
}

export function replaceValuesInObject(obj, toReplace, replacementValue) {
  Object.keys(obj).forEach((key) => {
    if (toReplace(obj[key])) {
      obj[key] = replacementValue;
    } else if (obj[key]) {
      if (obj[key] instanceof Array) {
        obj[key].forEach((rec) =>
          replaceValuesInObject(rec, toReplace, replacementValue),
        );
      } else if (obj[key] instanceof Object) {
        replaceValuesInObject(obj[key], toReplace, replacementValue);
      }
    }
  });
}

export function toTitleCase(str) {
  return (
    str &&
    str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    })
  );
}

export function trimTrailingSlash(path) {
  if (path) {
    const { length } = path;
    if (path.charAt(length - 1) === "/") {
      return path.substr(0, length - 1);
    }
  }
  return path;
}

export function validateEmail(email) {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
}

export function sum(vals) {
  return vals.reduce((total, val) => total + parseFloat(val || 0), 0);
}

// Check size of window to be consistent with our scss definition of mobile
export function isMobileView() {
  return window.innerWidth <= 600;
}
export function isTabletView() {
  return window.innerWidth <= 1040;
}

export function getDefaultCountryCode(
  countries,
  defaultCountryName,
) {
  const countryCode = defaultCountryName
    ? getCountryCodeByName(defaultCountryName, countries)
    : null;
  return countryCode || usCountryCode;
}

export function getCountryIdByCode(countryCode, countries) {
  const country = countries.find(
    (c) => c.code.toLowerCase() === countryCode.toLowerCase(),
  );
  return country?.id || null;
}

export function getCountryCodeById(countryId, countries) {
  const country = countries.find((c) => c.id === countryId);
  return country?.code.toLowerCase() || null;
}

export function getCountryCodeByName(countryName, countries) {
  if (countryName === "Scotland") countryName = "United Kingdom"; //note: no country support for scotland, use UK instead
  const country = countries.find((c) => c.name === countryName);
  return country?.code.toLowerCase() || usCountryCode;
}
